<ng-container>
  <div class="modal-container position-relative">
    <ng-content></ng-content>
  </div>
</ng-container>
